var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPropertRequest(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 23.357,
    height: 28.51,
    viewBox: "0 0 23.357 28.51",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_4208",
    "data-name": "Group 4208",
    transform: "translate(-310 -600.696)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "building",
    transform: "translate(310 605.25)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_14272",
    "data-name": "Path 14272",
    d: "M10.4,4H24.77a2.4,2.4,0,0,1,2.4,2.4V27.957H8V6.4A2.4,2.4,0,0,1,10.4,4Zm0,21.561h4.791V20.77h4.791v4.791H24.77V6.4H10.4Zm8.385-16.77h3.594v3.594H18.781Zm-5.989,5.989h3.594v3.594H12.791Zm5.989,0h3.594v3.594H18.781ZM12.791,8.791h3.594v3.594H12.791Z",
    transform: "translate(-8 -4)",
    fill: "#6a707e"
  })), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_10",
    "data-name": "Ellipse 10",
    cx: 5.94,
    cy: 5.94,
    r: 5.94,
    transform: "translate(321.479 600.696)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "plus-circle-fill",
    transform: "translate(322.245 601.922)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4196",
    "data-name": "Group 4196"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_14273",
    "data-name": "Path 14273",
    d: "M10.248,5.124A5.124,5.124,0,1,1,5.124,0a5.124,5.124,0,0,1,5.124,5.124Zm-4.8-2.242a.32.32,0,1,0-.641,0V4.8H2.882a.32.32,0,1,0,0,.641H4.8V7.366a.32.32,0,0,0,.641,0V5.444H7.366a.32.32,0,0,0,0-.641H5.444Z",
    fill: "#6a707e"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPropertRequest);
export default __webpack_public_path__ + "static/media/PropertRequest.08b2146631a5afb7641e3bf0390c50d9.svg";
export { ForwardRef as ReactComponent };